import React from 'react'
import { APP_PREFIX_PATH } from 'configs/AppConfig';

export class PazientiProtectedRoute {


    static pazienti = [
        {
            key: 'agenda',
            path: `${APP_PREFIX_PATH}/agenda`,
            component: React.lazy(() => import('views/app-views/agenda')),
        },
        {
            key: 'unavailability-slots',
            path: `${APP_PREFIX_PATH}/unavailability-slots`,
            component: React.lazy(() => import('views/app-views/unavailability-slots')),
        },
        {
            key: 'scheda-paziente',
            path: `${APP_PREFIX_PATH}/pazienti-appuntamenti/pazienti/:id`,
            component: React.lazy(() => import('views/app-views/pazienti/schedaPaziente')),
        },
        {
            key: 'pazienti-lista',
            path: `${APP_PREFIX_PATH}/pazienti/lista`,
            component: React.lazy(() => import('views/app-views/pazienti/listaPazienti')),
        },
        {
            key: 'pazienti-aggiungi',
            path: `${APP_PREFIX_PATH}/pazienti/aggiungi`,
            component: React.lazy(() => import('views/app-views/pazienti/nuovoPaziente')),
        },
        {
            key: 'pazienti-stato-lista',
            path: `${APP_PREFIX_PATH}/pazienti/stato/lista`,
            component: React.lazy(() => import('views/app-views/pazienti/gestioneStatiPazienti/listaTypes')),
        },
        {
            key: 'pazienti-stato-aggiungi',
            path: `${APP_PREFIX_PATH}/pazienti/stato/aggiungi`,
            component: React.lazy(() => import('views/app-views/pazienti/gestioneStatiPazienti/nuovoTypes')),
        },
        {
            key: 'provenienze-lista',
            path: `${APP_PREFIX_PATH}/provenienze/lista`,
            component: React.lazy(() => import('views/app-views/provenienze/listaProvenienze')),
        },
        {
            key: 'provenienze-aggiungi',
            path: `${APP_PREFIX_PATH}/provenienze/aggiungi`,
            component: React.lazy(() => import('views/app-views/provenienze/nuovaProvenienza')),
        },
        {
            key: 'report-mancanti',
            path: `${APP_PREFIX_PATH}/report-mancanti`,
            component: React.lazy(() => import('views/app-views/report-mancanti')),
        },
        {
            key: 'report-mancanti',
            path: `${APP_PREFIX_PATH}/richiami`,
            component: React.lazy(() => import('views/app-views/richiami')),
        },
    ];

    static pazientiSuperadmin = [
        ...this.pazienti,
        {
            key: 'estrazioni',
            path: `${APP_PREFIX_PATH}/estrazioni/pazienti`,
            component: React.lazy(() => import('views/app-views/estrazioni')),
        },

    ];


    static getNavTree() {
        return this.pazienti;
    }

    static getNavTreeSuperadmin() {
        return this.pazientiSuperadmin;
    }
}

export default PazientiProtectedRoute;
